import {
  ClientCardSubscription, ClientViewByIdDocument,
  useCallHistoryItemsQuery,
  useClientCardSubscription,
  WithCalls
} from '../index';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { useClientViewForAdviserQuery } from '@coverright/data-access/enrollment';
import { gql } from '@apollo/client';
import moment from 'moment/moment';

export type Client = WithCalls<ClientCardSubscription['clientCard']>

export type PropsWithClient<P = unknown> = P & { client: Partial<Client> };

export const useClientSubscription = (id?: string) => {
  const [client, setClient] = useState<Partial<Client>>(() => id ? getClientFromApolloCache(id) : {calls: []});
  useCallHistoryItemsQuery({
    variables: {clientId: id, page: {page: 0, size: 50}},
    skip: !id,
    onCompleted: data => setClient(prev => ({
      ...prev,
      calls: _.orderBy(data.callHistoryItems.data, (v: any) => moment(v.createdAt).toDate().getTime(), 'desc'),
      lastCall: _.orderBy(data.callHistoryItems.data, (v: any) => moment(v.createdAt).toDate().getTime(), 'desc')[0]
    }))
  })


  useClientViewForAdviserQuery({
    variables: {clientId: id},
    skip: !id,
    onCompleted: data => setClient(prev => ({
      ...prev,
      ..._.omit(data.clientViewForAdviser, ['clientId', 'callScheduled', '__typename', 'quoteCreated'])
    }))
  })

  const {data, loading} = useClientCardSubscription({ variables: { id }, skip: !id, client: enrollmentApolloClient });

  useEffect(() => {
    if (data?.clientCard) {
      setClient(prev => (
        data?.clientCard && !_.isEqual(data.clientCard, prev) ? {
          ...data.clientCard,
          calls: prev.calls,
          lastCall: prev.lastCall,
        } : prev
      ))
    }
  }, [data?.clientCard]);

  return {client, loading};
}

// -----------------------------

const getClientFromApolloCache = (id: string) => {
  // try to read full profile if it's already in cache
  let res = enrollmentApolloClient.readQuery({
    query : ClientViewByIdDocument,
    variables: {
      id: id
    }
  })
  if (res?.clientViewById) {
    return { ...res.clientViewById, calls: [] };
  }


  // try to read profile cached from list
  res = enrollmentApolloClient.readQuery({
    query : gql`
      query clientViewById($id: String) {
        clientViewById(id: $id) {
          id
          birthDate
          email
          firstName
          lastName
          phoneNumber
          phoneNumber2
          userId
          status
          state
          createdAt
          followUpDate
          expectedCloseDate
          tags {
            expiresAt
            tag {
              color
              id
              name
            }
          }
          affiliationPartnershipSource
          profileSource
          agent {
            firstName
          }
        }
      }
    `,
    variables: {
      id: id
    }
  })
  return res ? { ...res.clientViewById, calls: [] } : {calls: []};
}
